const licenseCheck = async (license = {}, blacklist = [], whitelist = []) => {
  console.log('license:', license);
  console.log('blacklist:', blacklist);
  console.log('whitelist:', whitelist);
  return 'licenseCheck Func';
};

//* Blacklist item check
function licenseBlacklistCheck(license = {}, blacklist = []) {
  // console.log('in blacklist check');
  // console.log('licenseBLK:', license);
  // console.log('blacklist', blacklist);
  if (!blacklist?.length) return false;
  const { permissions = [], trackingSystems = [], courses = [] } = license || {};

  if (trackingSystems === undefined && permissions === undefined && courses === undefined) {
    return false;
  }

  const isTrial = permissions.some((perm) => {
    const { authorized, key } = perm;
    return authorized && key === 'core.trial_license';
  });

  if (isTrial) {
    return false;
  }

  const isTSBlacklist = blacklist?.some((item) => {
    return trackingSystems?.some((ts) => {
      return ts.key.includes(item) && ts.authorized;
    });
  });
  const isPermissionBlacklist = blacklist?.some((item) => {
    return permissions?.some((p) => {
      return p.key.includes(item) && p.authorized;
    });
  });
  const isCourseBlacklist = blacklist?.some((item) => {
    return courses?.some((course) => {
      return course.key.includes(item) && course.authorized;
    });
  });

  return isTSBlacklist || isPermissionBlacklist || isCourseBlacklist;
}

//* Whitelist item check
function licenseWhitelistCheck(license = {}, whitelist = []) {
  // console.log('in whitelist check');
  // console.log('whitelist:', whitelist);
  if (!whitelist?.length || license.id === '000000') return true;
  const { permissions = [], trackingSystems = [], courses = [] } = license || {};
  const allPermissions = [...permissions, ...trackingSystems, ...courses];

  const matchesAllPermissions = whitelist.every((item) => {
    // Bypass if allow_core_creation
    if (item === 'allow_core_creation') {
      return true;
    }

    // Bypass any tracking_hardware permissions
    // Bypass desktop or mobile type permission
    if (
      item === 'desktop_license' ||
      item === 'mobile_license' ||
      item.includes('tracking_hardware.')
    ) {
      return true;
    }

    const permissionFound = allPermissions?.some((p) => {
      return p.key.includes(item) && p.authorized;
    });
    return permissionFound;
  });

  return matchesAllPermissions;

  //* These functions separately check each type of permission/TS/course
  //* It works, but above is a cleaner setup to make sure ALL items match
  //* ===========================================================================
  // const whitelistPermissions = whitelist.filter(
  //   (item) => !item?.includes('tracking_hardware.') && !item?.includes('course.')
  // );
  // const whiteListTS = whitelist.filter((item) => item?.includes('tracking_hardware.'));
  // const whiteListCourse = whitelist.filter((item) => item?.includes('course.'));

  // //* check permissions whitelist====================================================
  // const isPermissionWhitelist = whitelistPermissions?.every((item) => {
  //   if (item === 'allow_core_creation') return true;

  //   const includesPermission = permissions?.some((p) => p.key?.includes(item) && p.authorized);
  //   return includesPermission;
  // });

  // //* check tracking system whitelist=============================================
  // const isTSWhitelist = whiteListTS?.every((item) => {
  //   const includesTS = trackingSystems?.some((ts) => ts.key.includes(item) && ts.authorized);
  //   return includesTS;
  // });

  // //* check course whitelist======================================================
  // const isCourseWhitelist = whiteListCourse?.every((item) => {
  //   const includesCourse = courses?.some(
  //     (course) => course.key.includes(item) && course.authorized
  //   );
  //   return includesCourse;
  // });

  // return isTSWhitelist && isPermissionWhitelist && isCourseWhitelist;
}

//* SkyTrak item check
function licenseSkyTrakCheck(license = {}) {
  // console.log('in skytrak check');
  const { trackingSystems = [], permissions = [] } = license || {};
  if (trackingSystems === undefined) {
    return false;
  }

  const isTrial = permissions.some((perm) => {
    const { authorized, key } = perm;
    return authorized && key === 'core.trial_license';
  });

  if (isTrial) {
    return false;
  }

  const isSkyTrak = trackingSystems
    ?.filter((system) => {
      return system.authorized;
    })
    ?.some((item) => {
      return item.key.toLowerCase().includes('skytrak');
    });

  return isSkyTrak;
}

function allowCoreCheck(product = {}) {
  const { whitelist = [] } = product || {};
  const allowCore = whitelist?.some((item) => {
    return item === 'allow_core_creation';
  });
  return allowCore ?? false;
}

function allowCoreCheckAllProducts(products = []) {
  let mergedWhitelist = [];
  products.forEach((product) => {
    mergedWhitelist = [...mergedWhitelist, ...product.whitelist];
  });

  const allowCore = [...new Set([...mergedWhitelist])]?.some((item) => {
    return item === 'allow_core_creation';
  });

  return allowCore ?? false;
}

export {
  licenseCheck,
  licenseBlacklistCheck,
  licenseWhitelistCheck,
  licenseSkyTrakCheck,
  allowCoreCheck,
  allowCoreCheckAllProducts,
};
